import {
    GET_USER_FAILURE,
    GET_USER_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_SUCCESS,
    LOGOUT_SUCCESS,
    RESET_PASSWORD_FAILURE,
    RESET_PASSWORD_SUCCESS,
    SET_PASSWORD_SUCCESS,
    SIGN_UP_FAILURE,
    SIGN_UP_SUCCESS, SOCIAL_LOGIN_SUCCESS,
    SWITCH_NIGHT_MODE_SUCCESS,
    TOGGLE_NIGHT_CALLS_SUCCESS,
    UPDATE_PROFILE_INFO_FAILURE,
    UPDATE_PROFILE_INFO_SUCCESS,
} from "../actions/UserActions";
import {toast} from 'react-toastify';

const initialState = {
    ipIsoCode: undefined,
    user: {},
    authorized: undefined,
    registered: undefined,
    resetPasswordSent: undefined,
};

export default function UserReducer(state = initialState, action) {
    switch (action.type) {
        case SWITCH_NIGHT_MODE_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    preferences: {
                        ...state.user.preferences,
                        night_mode: action.payload.night_mode,
                    },
                },
            };

        case TOGGLE_NIGHT_CALLS_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    preferences: {
                        ...state.user.preferences,
                        night_calls: action.payload.night_calls,
                    },
                },
            };

        case SET_PASSWORD_SUCCESS:
        case UPDATE_PROFILE_INFO_SUCCESS:
            toast.success('Settings updated');

            return {
                ...state,
                user: action.payload,
            };

        case UPDATE_PROFILE_INFO_FAILURE:
            toast.error('Unable to save settings');

            return {
                ...state,
            };


        case GET_USER_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
                authorized: action.payload.authorized,
                // Geo rides on the user payload (single source). Guest + auth
                // both carry current_country_code_iso + geo_blocked.
                ipIsoCode: action.payload.ipIsoCode || 'us',
                geoBlocked: !!action.payload.geoBlocked,
            };

        case LOGIN_SUCCESS:
        case SOCIAL_LOGIN_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
                authorized: action.payload.authorized,
            };

        case SIGN_UP_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
                authorized: action.payload.authorized,
                registered: true
            };

        case GET_USER_FAILURE:
        case LOGIN_FAILURE:
            return {
                ...state,
                authorized: false,
            }

        case SIGN_UP_FAILURE:
            return {
                ...state,
                authorized: false,
                registered: false
            }

        case RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPasswordSent: !!(action.payload && action.payload.success),
            }

        case RESET_PASSWORD_FAILURE:
            return {
                ...state,
                resetPasswordSent: false,
            }

        case LOGOUT_SUCCESS:
            return {
                ...state,
                user: {},
                authorized: false,
            }
    }

    return state;
}
